import {
    initialPostDetailPageState,
    initialPostDetailState,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.constants';
import {
    PostDetailPageState,
    PostDetailState,
    PostDetailVirtualPageState,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.reducers';
import { PostEntity, PostSchema, TopicEntity, TopicSchema } from 'mk2/apps/forum/schemas';
import { AppState } from 'mk2/reducers';
import { findDenormalizedEntityByCond, findDenormalizedEntityBySlug } from 'mk2/selectors';

export const findPostDetailPost = (state: AppState, topicSlug: string, postSlug: string): PostEntity => {
    const topic = findDenormalizedEntityBySlug<TopicEntity>(state, TopicSchema, topicSlug);
    if (!topic) {
        return null;
    }

    return findDenormalizedEntityByCond<PostEntity>(
        state,
        PostSchema,
        `cacheKey-${findPostDetailPost.name}-${topic.id}-${postSlug}`,
        (normalizedPost: any) => normalizedPost.topic === topic.id && normalizedPost.slug === postSlug,
    );
};

export const getForumPostDetailState = (state: AppState, topicSlug: string, postSlug: string): PostDetailState =>
    state.containers.forum.forumPostDetail[`${topicSlug}/${postSlug}`] || initialPostDetailState;
export const getForumPostDetailPageState = (state: AppState, topicSlug: string, postSlug: string, page: number): PostDetailPageState =>
    getForumPostDetailState(state, topicSlug, postSlug).pages[page] || initialPostDetailPageState;
export const getForumPostDetailVirtualPageState = (state: AppState, topicSlug: string, postSlug: string, pageName: string): PostDetailVirtualPageState =>
    getForumPostDetailState(state, topicSlug, postSlug).virtualPages[pageName] || initialPostDetailPageState;
